export default "/_next/static/images/blogfooter-eba16b5a33baec6ee8d45a0b67e192e3.avif";